import React from 'react';
import SectionHeader from './SectionHeader';
import CurrencyInput from './CurrencyInput';
import NotesInput from './NotesInput';

/**
 * Section 11 — Charity
 */
export default function StepCharity({ data = {}, onChange }) {
  function set(field, value) {
    onChange({ ...data, [field]: value });
  }

  const total =
    (Number(data.charitable_gifting) || 0) +
    (Number(data.tithes_church) || 0);

  return (
    <div>
      <SectionHeader number={11} title="Charity" />

      <CurrencyInput
        id="charitable_gifting"
        label="Charitable Gifting"
        value={data.charitable_gifting ?? null}
        onChange={(val) => set('charitable_gifting', val)}
      />

      <div className="form-check mb-3">
        <input
          className="form-check-input"
          type="checkbox"
          id="qcd"
          checked={!!data.is_qualified_charitable_distribution}
          onChange={(e) =>
            set('is_qualified_charitable_distribution', e.target.checked)
          }
        />
        <label className="form-check-label small" htmlFor="qcd">
          Any of these are <strong>Qualified Charitable Distributions</strong> (QCD)
        </label>
      </div>

      <CurrencyInput
        id="tithes_church"
        label="Tithes / Church"
        value={data.tithes_church ?? null}
        onChange={(val) => set('tithes_church', val)}
      />

      {total > 0 && (
        <div className="cashflow-total-box mt-3">
          <span className="fw-semibold">9: Total Charity</span>
          <span className="cashflow-total-amount">
            ${total.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 })}
          </span>
        </div>
      )}

      <NotesInput value={data.notes} onChange={(val) => set('notes', val)} />
    </div>
  );
}
